import { Component, Input } from '@angular/core';

@Component({
  selector: 'company-logo-svg',
  template: `
    <div class="logo-grid" [ngClass]="{collapsed}">
      <svg *ngIf="!collapsed" viewBox="0 0 160 29" class="company-logo" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg">
        <path *ngFor="let val of company_logo_path_d_attributes" [ngStyle]="{fill}" [attr.d]="val.d"></path>
      </svg>
      <svg *ngIf="collapsed" viewBox="0 0 23.7 28.2" class="company-logo" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg">
        <path *ngFor="let val of company_logo_path_d_attributes" [ngStyle]="{fill}" [attr.d]="val.showWhenCollapsed ? val.d : ''"></path>
      </svg>
      <ng-container *ngIf="includeProductLogo">
        <div class="logo-divider"></div>
        <svg viewBox="0 0 43 12" xmlns="http://www.w3.org/2000/svg" class="product-logo">
          <path *ngFor="let val of product_logo_path_d_attributes" [ngStyle]="{fill}" [attr.d]="val"></path>
        </svg>
      </ng-container>
    </div>
  `,
  styles: [`
    .logo-grid {
      display: grid;
    }
    .logo-grid:has(.product-logo) {
      grid-template-columns: auto 3px auto;
      grid-auto-rows: min-content;
      gap: 0.7rem;
      align-items: center;
    }
    .logo-grid.collapsed {
      grid-template-columns: unset;
      grid-template-rows: auto 2px auto;
      gap: 0.9rem;
    }
    .company-logo {
      height: 100%;
    }
    .logo-grid:not(.collapsed) .product-logo {
      height: 50%;
    }
    .logo-divider {
      height: 100%;
      background: #8CF585;
    }

  `],
})
export class SvgUnrulyLogo {

  @Input() includeProductLogo: boolean = false;
  @Input() collapsed: boolean = false;
  @Input() fill: string = '#15003B';

  company_logo_path_d_attributes = [
    // N - 1st
    {
      showWhenCollapsed: true,
      d: 'M23.7372 12.1914C23.7372 4.75423 19.1199 0 11.8481 0C4.57625 0 -0.0410156 4.75562 -0.0410156 12.1914V28.1779H5.40205V11.9968C5.40205 7.8848 8.11382 4.87656 11.8481 4.87656C15.5824 4.87656 18.2941 7.8848 18.2941 11.9968V28.1779H23.7372V12.1914Z',
    },
    // E - 1st
    {
      showWhenCollapsed: false,
      d: 'M27.2148 14.0889C27.2148 21.8699 33.4084 28.1779 41.0485 28.1779C46.5962 28.1779 51.3794 24.8506 53.5849 20.0489H47.8558C46.3172 22.1502 43.9221 23.3347 41.0499 23.3347C36.8846 23.3347 33.46 20.4949 32.7639 16.4373H54.6896C54.8152 15.6725 54.8849 14.8897 54.8849 14.0889C54.8849 6.30792 48.6914 0 41.0513 0C33.4112 0 27.2176 6.30792 27.2176 14.0889H27.2148ZM32.6621 12.29C33.2494 7.78101 36.6642 4.84311 41.0485 4.84311C45.4328 4.84311 48.8476 7.73683 49.4349 12.29H32.6621Z',
    },
    // X - 1nd
    {
      showWhenCollapsed: false,
      d: 'M73.2003 28.1779L66.7919 18.8761L60.3877 28.1779H53.7715L63.4859 14.0742L53.791 0H60.4058L66.7919 9.27376L73.1821 0H79.7969L70.1007 14.0742L79.8151 28.1779H73.2003Z',
    },
    // X - 2st
    {
      showWhenCollapsed: false,
      d: 'M86.8004 28.1779L93.2087 18.8761L99.6129 28.1779H106.229L96.5148 14.0742L106.21 0H99.5948L93.2087 9.27376L86.8185 0H80.2037L89.8999 14.0742L80.1855 28.1779H86.8004Z',
    },
    // E - 2st
    {
      showWhenCollapsed: false,
      d: 'M118.951 0C111.311 0 105.117 6.30792 105.117 14.0889C105.117 14.8897 105.186 15.6738 105.312 16.4373H127.238C126.542 20.4949 123.118 23.3347 118.952 23.3347C116.08 23.3347 113.685 22.1502 112.146 20.0489H106.417C108.623 24.8506 113.405 28.1779 118.954 28.1779C126.594 28.1779 132.787 21.8699 132.787 14.0889C132.787 6.30792 126.594 0 118.954 0H118.951ZM110.564 12.29C111.152 7.73683 114.567 4.84311 118.951 4.84311C123.335 4.84311 126.75 7.78101 127.337 12.29H110.564Z',
    },
    // N - 2nd
    {
      showWhenCollapsed: false,
      d: 'M136.262 12.1914C136.262 4.75423 140.879 0 148.151 0C155.423 0 160.04 4.75562 160.04 12.1914V28.1779H154.597V11.9968C154.597 7.8848 151.885 4.87656 148.151 4.87656C144.417 4.87656 141.705 7.8848 141.705 11.9968V28.1779H136.262V12.1914Z',
    },
  ];

  product_logo_path_d_attributes = [
    // C
    'M0.5 6C0.5 4.8507 0.779201 3.81972 1.3376 2.90704C1.90789 1.99437 2.6742 1.28451 3.63655 0.777465C4.61079 0.259155 5.67413 0 6.82657 0C8.14535 0 9.31562 0.309859 10.3374 0.929578C11.371 1.53803 12.1195 2.40563 12.5829 3.53239H10.1413C9.82055 2.91268 9.37502 2.45071 8.80474 2.14648C8.23446 1.84225 7.57507 1.69014 6.82657 1.69014C6.00679 1.69014 5.27612 1.86479 4.63455 2.21409C3.99298 2.56338 3.48804 3.06479 3.11974 3.71831C2.76331 4.37183 2.5851 5.13239 2.5851 6C2.5851 6.86761 2.76331 7.62817 3.11974 8.28169C3.48804 8.93521 3.99298 9.44225 4.63455 9.80282C5.27612 10.1521 6.00679 10.3268 6.82657 10.3268C7.57507 10.3268 8.23446 10.1746 8.80474 9.87042C9.37502 9.5662 9.82055 9.10423 10.1413 8.48451H12.5829C12.1195 9.61127 11.371 10.4789 10.3374 11.0873C9.31562 11.6958 8.14535 12 6.82657 12C5.66225 12 4.59891 11.7465 3.63655 11.2394C2.6742 10.7211 1.90789 10.0056 1.3376 9.09296C0.779201 8.18028 0.5 7.1493 0.5 6Z',
    // T
    'M22.9627 0.152113V1.72394H19.6657V11.8986H17.6341V1.72394H14.3193V0.152113H22.9627Z',
    // R
    'M31.4537 11.8986L28.6023 7.2H27.0518V11.8986H25.0202V0.152113H29.2973C30.2478 0.152113 31.0497 0.309859 31.7032 0.625352C32.3685 0.940845 32.8616 1.36338 33.1824 1.89296C33.515 2.42254 33.6814 3.01409 33.6814 3.66761C33.6814 4.4338 33.4438 5.13239 32.9685 5.76338C32.5052 6.3831 31.7864 6.80563 30.8121 7.03099L33.8774 11.8986H31.4537ZM27.0518 5.66197H29.2973C30.0577 5.66197 30.628 5.48169 31.0082 5.12113C31.4002 4.76056 31.5963 4.27606 31.5963 3.66761C31.5963 3.05916 31.4062 2.58592 31.026 2.24789C30.6458 1.89859 30.0696 1.72394 29.2973 1.72394H27.0518V5.66197Z',
    // L
    'M38.312 10.3437H42.5V11.8986H36.2804V0.152113H38.312V10.3437Z',
  ];

}
